import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { fetchDocumentLibraries } from "../../../lib/api/resources/documentLibraries";
import { documentLibraryColumns } from "./lib/constants/documentLibraryColumns";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";

export const DocumentLibrariesList = () => {
  const documentLibrariesQuery = useQuery({
    queryKey: ["documentLibraries"],
    queryFn: fetchDocumentLibraries,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/document-libraries/create">
          <Button icon={<PlusOutlined />}>Nieuwe bibliotheek</Button>
        </Link>
      </Space>
      <Table
        columns={documentLibraryColumns}
        dataSource={documentLibrariesQuery.data?.member}
        loading={documentLibrariesQuery.isFetching}
        pagination={false}
        rowKey="id"
      />
    </div>
  );
};
